import Vue from 'vue'

/**
 * Click outside event support
 *
 * Usage:
 *    <div v-click-outside="handler">...</div>
 */

Vue.directive('click-outside', {
  bind(el, binding) {
    const isBubble = binding.modifiers.bubble
    const fn = binding.value

    if (typeof fn !== 'function') {
      return false
    }

    el.__clickOutside__ = e => {
      if (isBubble) {
        return fn(e)
      }
      if (!el.contains(e.target) && el !== e.target) {
        fn(e)
      }
    }
    document.addEventListener('click', el.__clickOutside__)
  },
  unbind(el) {
    document.removeEventListener('click', el.__clickOutside__)
    el.__eventName__ = null
    el.__clickOutside__ = null
  }
})
